import { Component, Input } from '@angular/core';
import { AccommodationsService } from '../../accommodations.service';
import { Product } from '@/accommodations/accommodations.model';
import { RoomAvailabilityState } from '@/reservation/reservation.model';

@Component({
	selector: 'app-accommodations-products-rooms',
	templateUrl: './accommodations-products-rooms.component.html',
	styleUrls: ['./accommodations-products-rooms.component.scss'],
})
export class AccommodationsProductsRoomsComponent {
	@Input() room;
	@Input() name = '';
	@Input() occupancy = '';
	@Input() product: Product;

	constructor(protected _service: AccommodationsService) {}

	protected reservationMoveHere(room: RoomAvailabilityState): void {
		this._service.reservationMoveHere(room, this.product);
	}
}
